import axios from 'axios';
import { storage, resetStorages } from 'utils/appLocalStorage';

let refreshPromise = null;
let onSessionInvalid = null;

export function setOnSessionInvalid(callback) {
  onSessionInvalid = callback;
}

export function getAccessToken() {
  return (
    localStorage.getItem(storage.accessToken) ||
    localStorage.getItem(storage.token)
  );
}

export function getRefreshToken() {
  return localStorage.getItem(storage.refreshToken);
}

export function persistSessionTokens({ accessToken, refreshToken }) {
  if (accessToken) {
    localStorage.setItem(storage.accessToken, accessToken);
    localStorage.removeItem(storage.token);
  }
  if (refreshToken) {
    localStorage.setItem(storage.refreshToken, refreshToken);
  }
}

export function clearSessionTokens() {
  localStorage.removeItem(storage.accessToken);
  localStorage.removeItem(storage.refreshToken);
  localStorage.removeItem(storage.token);
}

export function isAuthRefreshUrl(url = '', method = 'get') {
  const path = String(url).split('?')[0];
  const normalizedMethod = String(method).toLowerCase();

  if (path.includes('/session/refresh') || path.includes('/session/logout')) {
    return true;
  }

  return normalizedMethod === 'post' && /\/session\/?$/.test(path);
}

export function classifyRefreshFailure(error) {
  if (!error) {
    return 'unauthorized';
  }

  if (error.refreshKind) {
    return error.refreshKind;
  }

  const status = error.response?.status;
  const type = error.response?.data?.type;

  if (type === 'financeiro') {
    return 'financial';
  }

  if (
    !error.response ||
    error.code === 'ECONNABORTED' ||
    error.code === 'ERR_NETWORK'
  ) {
    return 'network';
  }

  if (status === 401) {
    return 'unauthorized';
  }

  if (status >= 500) {
    return 'server';
  }

  if (status >= 400) {
    return 'unauthorized';
  }

  return 'network';
}

export function notifySessionInvalid(payload) {
  if (typeof onSessionInvalid === 'function') {
    onSessionInvalid(payload);
    return;
  }
  resetStorages();
}

async function requestRefresh(apiUrl) {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    const error = new Error('Refresh token ausente');
    error.refreshKind = 'unauthorized';
    throw error;
  }

  try {
    const { data } = await axios.post(
      `${apiUrl.replace(/\/$/, '')}/session/refresh`,
      { refreshToken },
      {
        headers: { 'Content-Type': 'application/json' },
        timeout: 30000,
      },
    );

    persistSessionTokens({
      accessToken: data.accessToken,
      refreshToken: data.refreshToken,
    });

    return data;
  } catch (error) {
    const kind = classifyRefreshFailure(error);
    error.refreshKind = kind;
    throw error;
  }
}

export function refreshSession(apiUrl) {
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = requestRefresh(apiUrl).finally(() => {
    refreshPromise = null;
  });

  return refreshPromise;
}
